import { render, staticRenderFns } from "./SubjectCategoryView.vue?vue&type=template&id=7fc50c9a&"
import script from "./SubjectCategoryView.vue?vue&type=script&lang=js&"
export * from "./SubjectCategoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports